// Centralized configuration — single source of truth for API base URL
// In production, REACT_APP_API_URL must be set at build time.
// Dev mode falls back to localhost; production build fails loud if missing.

function getApiBase() {
  const envUrl = process.env.REACT_APP_API_URL;
  if (envUrl) return envUrl;

  if (process.env.NODE_ENV === 'production') {
    console.error('[config] REACT_APP_API_URL is not set in production build!');
    // Use relative URL as a safe fallback (works when frontend and API share the same domain)
    return '';
  }

  return 'http://localhost:8787';
}

export const API_BASE = getApiBase();

// Sentry error tracking (optional — leave REACT_APP_SENTRY_DSN empty to disable)
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || '';
